import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { AddProgramComponent } from './add-program/add-program.component';
import { Config } from '@ionic/angular';
import { FacultyNamePopupComponent } from './faculty-name-popup/faculty-name-popup.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApproveemployeepopupComponent } from './approveemployeepopup/approveemployeepopup.component';

@Component({
  selector: 'app-training-calendor',
  templateUrl: './training-calendor.component.html',
  styleUrls: ['./training-calendor.component.scss'],
})
export class TrainingCalendorComponent  implements OnInit {

  programForm!: FormGroup;
  selectedTabIndex: number = 0;  // Default tab is "Create Calendar"

    selectedTypeTabIndex: number = 0;
    selectedTypeTabName = 'dashboard'
    buttonColorName: any;
    showSetupPopup: boolean = false;
  
    constructor(
      public router: Router,
      private activatedroute: ActivatedRoute,private dialog: MatDialog, private config: Config,private fb: FormBuilder
    ) { }
    ngOnInit() {
      this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.selectedTypeTabName = "createcalendar";
      this.programForm = this.fb.group({
        selectedProgram: [''] // Default empty selection
      });
    }

   
    tabTypeChanged(event: MatTabChangeEvent) {
      this.selectedTypeTabName = event.tab.textLabel;
      this.selectedTypeTabIndex = event?.index;
    }
  
    onClickSetup(operation: any) {
      this.router.navigate(['/home/hrportal/lnd-setup', { operation: operation }]);
  
    }
  
    onClickback() {
      this.router.navigate(['/home/hrportal/lnd']);
  
    }
  

    
//  ----------------------------------Start Calendar ------------------------------------
programList: string[] = ['Program 1', 'Program 2']; 

trainingPrograms = [
  {
    trainingType: 'LMS',
    title: 'Problem Solving',
    code: 'PS001',
    lmsLink: 'link',
    startDate: '1-10-24',
    endDate: '15-10-24',
    category: 'Functional',
    department: 'Sales',
    band: 'A',
    grade: 'Leader',
    location: 'Pune',
    programDays: 12,
    budgetCost: 'Rs.300',
    actualCost: 'Rs.350',
    facultyname:'mr das',
    objective: 'Strong',
    
  },
  {
    trainingType: 'Offline',
    title: 'Excel',
    code: 'EX002',
    lmsLink: 'link',
    startDate: '3-10-24',
    endDate: '23-10-24',
    category: 'Behavioral',
    department: 'Accounts',
    band: 'B',
    grade: 'Executive',
    location: 'Mumbai',
    programDays: 13,
    budgetCost: 'Rs.400',
    actualCost: 'Rs.400',
    facultyname:'mr das',
    objective: 'Improve'
  }
];






// Define headers dynamically
tableHeaders = [
  { label: 'Training Type', key: 'trainingType' },
  { label: 'Programme Title', key: 'title' },
  { label: 'Programme Code', key: 'code' },
  { label: 'LMS Link', key: 'lmsLink' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Functional/Behavioral', key: 'category' },
  { label: 'Dept.', key: 'department' },
  { label: 'Band', key: 'band' },
  { label: 'Grade', key: 'grade' },
  { label: 'Location', key: 'location' },
  { label: 'No. of Program Days', key: 'programDays' },
  { label: 'Budget Cost', key: 'budgetCost' },
  { label: 'Actual Cost', key: 'actualCost' },
  { label: 'Faculty name', key: 'facultyname' },
  { label: 'Objective', key: 'objective' },
  { label: 'Action' }
];


 // Table Headers
 employeeTableHeaders = [
  { label: 'Emp Code' },
  { label: 'Emp Name' },
  { label: 'Department' },
  { label: 'Band' },
  { label: 'Grade' },
  { label: 'Nominated by which HOD' },
  { label: 'Status' }
];

employeeTrainingPrograms = [
  { code: 'B001', name: 'Ram', department: 'Sales', band: 'A', grade: 'Junior', nominatedBy: 'Narayan', status: 'Approved', selected: false },
  { code: 'B002', name: 'Laksham', department: 'Marketing', band: 'B', grade: 'Manager', nominatedBy: 'Tim', status: 'Pending', selected: false }
];


// Approve Selected Rows
approveSelected() {
  console.log('approve is clicked')
  const dialogRef = this.dialog.open(ApproveemployeepopupComponent, {
       disableClose: true,
       height: '25%',
       width: '30%',
       data: {
         msg: 'Are you sure you want to approve these employess for the programme selected?',
         btn1: 'Cancel',
         btn2: 'Confirm',
         btn2BgColor: this.buttonColorName,
         showSuccessIcon: false,
         showSuccessMessage: false,
         showCloseIcon: false,
       },
     });
 
}

// Reject Selected Rows
rejectSelected() {
  console.log('reject is clicked')
  const dialogRef = this.dialog.open(ApproveemployeepopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: 'Are you sure you want to reject these employess for the programme selected?',
      btn1: 'Cancel',
      btn2: 'Confirm',
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: false,
      showSuccessMessage: false,
      showCloseIcon: false,
    },
  });
}

// Select/Deselect All
selectAll(event: any) {
  const isChecked = event.checked;
  this.employeeTrainingPrograms .forEach(program => program.selected = isChecked);
}


facultyNamePopup()
{
     const dialogConfig = new MatDialogConfig();
            dialogConfig.height = '70%';
            dialogConfig.width = '70%';
            dialogConfig.data = {};
            dialogConfig.panelClass = 'custom-dialog-container';
            const dialogRef = this.dialog.open(FacultyNamePopupComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(result => {
              
            });
}

editProgram(){
  const dialogConfig = new MatDialogConfig();
  dialogConfig.height = '70%';
  dialogConfig.width = '70%';
  dialogConfig.data = {};
  dialogConfig.panelClass = 'custom-dialog-container';
  const dialogRef = this.dialog.open(AddProgramComponent, dialogConfig);
  dialogRef.afterClosed().subscribe(result => {
    
  });
}


deleteProgram(){

}

onClickAddNewProgramPopup(){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = '70%';
      dialogConfig.width = '70%';
      dialogConfig.data = {};
      dialogConfig.panelClass = 'custom-dialog-container';
      const dialogRef = this.dialog.open(AddProgramComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        
      });
    }
// ---------------------------------End Calender---------------------------------------


}
